export const magazineConstants = {
    GET_MAGAZINES_SUCCESS: 'GET_MAGAZINES_SUCCESS',
    GET_MAGAZINES_ERROR: 'GET_MAGAZINES_ERROR',
}
